import { setObjectUrl } from '../actions/createObjectUrlForFileBlob';
import type InlineImageViewState from '../schema/InlineImageViewState';
import createLogger from '../utils/logger';
import { EditorViewState, lazyOperateContent } from 'owa-editor';
import getObjectUrlAndDataUrl from '../utils/getObjectUrlAndDataUrl';
import { createAndSetImageInEditor } from './insertInlineImages';
import type { AttachmentModel } from 'owa-attachment-model-store';

export default async function insertInlineImageFromAttachmentWell(
    attachment: AttachmentModel,
    editorViewState: EditorViewState,
    inlineImageViewState: InlineImageViewState
) {
    const attachmentUrl = attachment.model.AttachmentOriginalUrl || '';
    const logger = createLogger(editorViewState.editorId);
    const { objectUrl, dataUrl } = (await getObjectUrlAndDataUrl(attachmentUrl, logger)) || {};

    const operateContent = await lazyOperateContent.import();

    if (objectUrl && dataUrl) {
        operateContent(editorViewState, editor => {
            editor.focus();
            editor.addUndoSnapshot(() => {
                if (objectUrl) {
                    setObjectUrl(inlineImageViewState, objectUrl, dataUrl);
                }
                createAndSetImageInEditor(editor, objectUrl || attachmentUrl, attachment);
                logger('newImage', 'insertImage');
            }, 'InsertImage');
            return null;
        });
    }
}
